import { createReducer } from '@reduxjs/toolkit'
import { types } from 'actions/surveys_element'
import _ from 'underscore'
import { SCOPE_ALL } from '../../components/admin/surveys/template_association/association_options/constants'

function maxPosition (state) {
  const fields = state.fields || []
  if (fields.length === 0) {
    return 0
  }

  const field = fields.reduce((a, b) => (parseInt(a.position, 10) > parseInt(b.position, 10) ? a : b))
  return parseInt(field.position, 10)
}
function fieldIndexByPosition(state, position) {
  return (state.fields || []).findIndex(f => f.position == position)
}

function removeFieldReducer (state, action) {
  const idx = fieldIndexByPosition(state, action.position)
  if (idx === -1) return
  
  const field = state.fields[idx]
  const id = field.id
  
  state.fields.splice(idx, 1)
  
  if (id) {
    if (!state.deletedIds) state.deletedIds = []
    state.deletedIds.push(id)
  }
}
function changePositionReducer (state, action) {
  const startIndex = fieldIndexByPosition(state, action.startPosition)
  const endIndex = fieldIndexByPosition(state, action.endPosition)
  
  if (startIndex === -1 || endIndex === -1) return
  
  const startField = { ...state.fields[startIndex] }
  const endField = { ...state.fields[endIndex] }
  
  state.fields[startIndex] = { ...endField, position: action.startPosition }
  state.fields[endIndex] = { ...startField, position: action.endPosition }
}

function changeInputValueReducer (state, action) {
  const idx = fieldIndexByPosition(state, action.position)
  if (idx === -1) return
  
  state.fields[idx][action.name] = action.value
  
  if (action.name === 'template_field') {
    delete state.fields[idx].default_value
  }
}


export default createReducer({}, (builder) => {
  builder
    .addCase(types.LOAD_TEMPLATES, (state, action) => {
      state.templates = action.templates
    })
    .addCase(types.LOAD_FIELDS, (state, action) => {
      state.fields = action.fields.map(f => ({ ...f, uid: _.uniqueId() }))
    })
    .addCase(types.LOAD_SIBLINGS, (state, action) => {
      state.siblings = action.siblings
    })
    .addCase(types.CHANGE_INPUT_VALUE, (state, action) => {
      changeInputValueReducer(state, action)
    })
    .addCase(types.ADD_FIELD, (state, action) => {
      if (!state.fields) state.fields = []
      state.fields.push({ ...action.params, position: maxPosition(state) + 1, uid: _.uniqueId() })
    })
    .addCase(types.REMOVE_FIELD, (state, action) => {
      removeFieldReducer(state, action)
    })
    .addCase(types.CHANGE_POSITION, (state, action) => {
      changePositionReducer(state, action)
    })
    .addCase(types.SELECT_TEMPLATE, (state, action) => {
      state.templateId = action.templateId.toString()
    })
    .addCase(types.ADD_TEMPLATE_FIELD, (state, action) => {
      if (!state.templateFields) state.templateFields = {}
      state.templateFields[action.id] = { name: action.name, value: action.value }
    })
    .addCase(types.REMOVE_TEMPLATE_FIELD, (state, action) => {
      if (state.templateFields) {
        delete state.templateFields[action.id]
      }
    })
    .addCase(types.SELECT_TEMPLATE_FIELD, (state, action) => {
      if (!state.templateFields) state.templateFields = {}
      if (!state.optionFields) state.optionFields = {}
      
      state.templateFields[action.id] = { ...state.templateFields[action.id], value: action.field }
      state.optionFields[action.id] = {
        ...state.optionFields[action.id],
        value: [],
        associations: [],
        optionsType: SCOPE_ALL
      }
    })
    .addCase(types.LOAD_ASSOCIATIONS, (state, action) => {
      if (!state.optionFields) state.optionFields = {}
      if (!state.optionFields[action.id]) state.optionFields[action.id] = {}
      state.optionFields[action.id].associations = action.data
    })
    .addCase(types.LOAD_LOCATION_ELEMENT_ASSOCIATIONS, (state, action) => {
      if (!state.optionFields) state.optionFields = {}
      if (!state.optionFields[action.id]) state.optionFields[action.id] = {}
      state.optionFields[action.id].associations = action.data
    })
    .addCase(types.SELECT_DEFAULT_ASSOCIATION, (state, action) => {
      if (!state.optionFields) state.optionFields = {}
      if (!state.optionFields[action.id]) state.optionFields[action.id] = {}
      state.optionFields[action.id].defaultOption = action.value
    })
})
